import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    directoryNav: {
        /** Aria label for toggling project navigation */
        accessibility: string;
        /** Label when hiding project navigation */
        hide: string;
        /** Label when showing project navigation */
        show: string;
    };
    viewer: {
        /** Aria label for toggling asset viewer */
        accessibility: string;
        /** Label when hiding asset viewer */
        hide: string;
        /** Label when showing asset viewer */
        show: string;
    };
    details: {
        /** Aria label for toggling asset info */
        accessibility: string;
        /** Label when hiding asset info */
        hide: string;
        /** Label when showing asset info */
        show: string;
    };
    ai: {
        /** Aria label for toggling AI panel */
        accessibility: string;
        /** Label when hiding AI panel */
        hide: string;
        /** Label when showing AI panel */
        show: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Project navigation panel toggle labels */
            directoryNav: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Aria label for toggling project navigation */
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.directoryNav.accessibility?c=1bazrwnmy8ccb", defaultMessage: "Toggle the Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when hiding project navigation */
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.directoryNav.hide?c=lntz05bdbtl4", defaultMessage: "Hide Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when showing project navigation */
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.directoryNav.show?c=9rg4whmyumvu", defaultMessage: "Show Project Navigation" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Asset viewer panel toggle labels */
            viewer: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Aria label for toggling asset viewer */
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.viewer.accessibility?c=18t1na8rqu2h6", defaultMessage: "Toggle the Asset Viewer" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when hiding asset viewer */
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.viewer.hide?c=479wca2w431s", defaultMessage: "Hide Asset Viewer" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when showing asset viewer */
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.viewer.show?c=1ozhs4wqu3fs0", defaultMessage: "Show Asset Viewer" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Asset info panel toggle labels */
            details: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Aria label for toggling asset info */
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.details.accessibility?c=3i6osgokkyzmy", defaultMessage: "Toggle the Asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when hiding asset info */
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.details.hide?c=1jj9k48hksw7v", defaultMessage: "Hide Asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when showing asset info */
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.details.show?c=p6b76q673edj", defaultMessage: "Show Asset Info" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** AI panel toggle labels */
            ai: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Aria label for toggling AI panel */
                        accessibility: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.ai.accessibility?c=1umjiqoqq0dlm", defaultMessage: "Toggle the AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when hiding AI panel */
                        hide: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.ai.hide?c=10ebb25ywjma3", defaultMessage: "Hide AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label when showing AI panel */
                        show: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "project.ai.show?c=2gqg8jp2a38j8", defaultMessage: "Show AI Panel" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
